import Enumerable from "linq";
import { IHisInformationApplicable, instanceOfIHisInformationApplicable } from "../../../../domain/document/items";
import { HisItemSelectAction } from "../../../../domain/his/action";
import { HisItemBehaviorFactory, ScreenKinds } from "../../../../domain/his/behavior";
import { IDocumentEditable } from "../IDocumentEditable";
import { User } from "../../../../domain/user";

/**
 * 文書編集中に特定のHIS項目を職員選択ダイアログから選択したとき、文書内のすべてのオブジェクトを連動して変更させる
 */
export class SpecifiedUserHisItemApplicator {
  constructor(private _document: IDocumentEditable, private _hisItemParameterKey: string) {}

  public isTargetObject(item: IHisInformationApplicable): boolean {
    return item && item.hisItemParameter && (item.hisItemParameter.key === this._hisItemParameterKey);
  }

  public apply(action: HisItemSelectAction): void {
    // 異なるitemSetIdにも反映するようにしている
    for (let itemSetId = 0; itemSetId < this._document.itemSets.length; ++itemSetId) {
      for (const item of this._document.itemSets[itemSetId].items) {
        if (!instanceOfIHisInformationApplicable(item) || !this.isTargetObject(item)) { continue; }
        const behavior = HisItemBehaviorFactory.create(item.hisItemParameter.key, null, item.hisItemParameter.objectKind);
        const hisInfoValue = behavior.getValue(action.informationItems);
        const cloned = item.clone() as IHisInformationApplicable;
        cloned.setHisInfoItems(hisInfoValue, false);
        cloned.setSelectedItems(this.getSelectedUsers(action));
        cloned.adjustObjectHeight();
        cloned.adjustFontSize();
        this._document.updateItem(cloned, {
          itemSetId,
        });
      }
    }
  }

  private getSelectedUsers(action: HisItemSelectAction): User[] {
    const users = Enumerable.from(action.selectedHisItemSets)
      .where(i => i.screenKind === ScreenKinds.Doctor)
      .select(s => s.items as User[])
      .firstOrDefault();
    // selectedHisItemSetsはリアクティブになっているので、解除するためにconcatしている
    return (!users || users.length === 0)
      ? null
      : users.concat();
  }
}
